import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5axa44u24: FaireProductEntity = {
  token: "p_g5axa44u24",
  type: "product",
  name: "Pink Shiny Simple Acrylic Bracelets DP25B569",
  brandToken: "b_kw6x2ac3kg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/21b6f358be1c614d5c83e29de4124cf681be6f0d6de496e659ef40a8a1dde661.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f447839c858a084dde116bd782f0393154ba2525aa8df289f4f6cc421d9c8446.jpeg",
    "https://cdn.faire.com/fastly/84d501110dbae141132626ffb29f9ee901aec78575336277a7daaa5654b7a94e.jpeg",
    "https://cdn.faire.com/fastly/7cc1c47cd3bb801cf88fa4b815fd355c0bc10be907c92dce7cb458faa34249da.jpeg",
    "https://cdn.faire.com/fastly/58b5e4304d174f39629afeb466ac85278a7b9925e207320c94744b9bbbe2c3a1.jpeg",
    "https://cdn.faire.com/fastly/93eadc956f88ebbf7c5f4ceee0de55dc26263f92a50595598ec0c3b3bd2dbe08.jpeg",
    "https://cdn.faire.com/fastly/026e6c6bfd283351bfc3c32a0e83a9e5188b05099fd980caccd3585e1d0350f2.jpeg",
    "https://cdn.faire.com/fastly/6614b5d37d7d0610b158bc96ececf1b9cf14f5d078ffadbc3f0220b63cc84980.jpeg",
  ],
  priceDollars: 5.25,
  description:
    "Feature:\n * Irregular \n * Shiny \n * Layered Wear\n * Smooth Surface\n * Simple, Versatile, Delicate \n * Daily Fitting\n * Gift\n\n Weigh:\n * 80g\n\n Material:\n * Acrylic\n\n Package:\n * Package include 1 bracelet.\n\n Note:\n * Manual measurement, due to different measurement methods, 1-3CM error is a normal phenomenon\n * Due to the different shooting lights and electronic screen display, the color of the model image will be different. The color of a single product is subject to the actual product.",
  tags: [],
  msrpDollars: 10.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:40.868Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
